export default {
    data() {
      return {
        showRecordVisibility: false,
        selectedVideoConfigs: [],
      };
    },
    methods: {
      showRecordModal(info) {
        console.log(info)
        this.selectedVideoConfigs = [info];
        this.showRecordVisibility = true;
      },
    },
  };
  